export const auth = {
  login: "Anmelden",
  loginSubtitle: "Melden Sie sich bei Ihrem Konto an",
  register: "Registrieren",
  registerSubtitle: "Erstellen Sie ein neues Konto",
  usernamePlaceholder: "Benutzername",
  emailPlaceholder: "ihre.email@beispiel.de",
  email: "E-Mail-Adresse",
  password: "Passwort",
  confirmPassword: "Passwort bestätigen",
  forgotPassword: "Passwort vergessen",
  noAccount: "Noch kein Konto",
  hasAccount: "Bereits ein Konto",
  loginButton: "Anmelden",
  registerButton: "Registrieren",
  loginSuccess: "Erfolgreich eingeloggt!",
  welcomeBack: "Willkommen zurück, {{name}}",
  passwordRequirementsTitle: "Passwort-Anforderungen:",
  passwordRequirementLength: "Mindestens 8 Zeichen",
  passwordRequirementUppercase: "Mindestens ein Großbuchstabe",
  passwordRequirementLowercase: "Mindestens ein Kleinbuchstabe",
  passwordRequirementNumber: "Mindestens eine Ziffer",
  passwordRequirementSpecial: "Mindestens ein Sonderzeichen",
  passwordsDoNotMatch: "Passwörter stimmen nicht überein",
  passwordsMatch: "Passwörter stimmen überein",
  registrationLoading: "Registrierung läuft...",
  verifyEmailTitle: "E-Mail bestätigen",
  verifyEmailSubtitle: "Vielen Dank für Ihre Registrierung!",
  verifyEmailSent:
    "Wir haben Ihnen eine E-Mail an {{email}} gesendet. Bitte klicken Sie auf den Link, um Ihr Konto zu aktivieren.",
  verifyEmailNextStep:
    "Nach der Bestätigung können Sie sich mit Ihren Zugangsdaten anmelden.",
  registrationCompleteTitle: "Registrierung abgeschlossen",
  registrationCompleteSubtitle: "Vielen Dank für Ihre Registrierung!",
  registrationCompleteBody:
    "E-Mail-Verifizierung ist in dieser Umgebung nicht erforderlich.",
  registrationCompleteNextStep:
    "Sie können sich jetzt mit Ihrem neuen Konto anmelden.",
  verificationEmailSent: "Verifizierungs-E-Mail versendet.",
  verifyBeforeLogin: "Bitte bestätigen Sie Ihre E-Mail, bevor Sie sich anmelden.",
  verificationNotRequired:
    "E-Mail-Verifizierung ist in dieser Umgebung nicht erforderlich.",
  verificationNotRequiredHint:
    "Kann nach dem Hinzufügen einer Mail Verbindung in application-local.properties aktiviert werden.",
  invalidCredentials: "E-Mail oder Passwort ist falsch.",
  accountNotVerified: "Ihr Konto ist noch nicht verifiziert.",
  accountLocked: "Ihr Konto wurde deaktiviert. Bitte kontaktieren Sie den Support.",
  accountLockedTemporary:
    "Ihr Login ist vorübergehend gesperrt. Bitte warten Sie oder setzen Sie Ihr Passwort zurück.",
  accountLockedTemporaryTitle: "Login vorübergehend gesperrt",
  accountLockedTemporaryMessage:
    "Zu viele Fehlversuche. Bitte versuchen Sie es in {{time}} erneut.",
  accountLockedTemporaryHint:
    "Ein Passwort-Reset hebt die Sperre sofort auf.",
  verifyEmailTokenMissing: "Token fehlt.",
  verifyEmailSuccess: "E-Mail erfolgreich bestätigt! Sie können sich nun einloggen.",
  verifyEmailInvalidToken: "Ungültiger oder nicht gefundener Token.",
  verifyEmailAlreadyUsed: "E-Mail wurde bereits bestätigt.",
  verifyEmailExpired: "Der Bestätigungslink ist abgelaufen.",
  verifyAccountTitle: "E-Mail-Bestätigung erforderlich",
  verifyAccountSubtitle:
    "Sie haben sich erfolgreich registriert und angemeldet, aber Ihr Konto ist noch nicht aktiv.",
  verifyAccountBody:
    "Wir haben eine Bestätigungs-E-Mail an {{email}} gesendet.",
  verifyAccountNextStep:
    "Bitte klicken Sie auf den Link in dieser E-Mail, um Ihren Account freizuschalten.",
  verifyAccountSpamHint:
    "Falls die E-Mail nicht angekommen ist, prüfen Sie bitte auch den Spam- oder Junk-Ordner.",
  verifyAccountResendHint:
    "Falls Sie keine E-Mail erhalten haben, können Sie den Link erneut anfordern.",
  verifyAccountResendButton: "Bestätigungslink erneut senden",
  verifyAccountResendButtonCooldown: "Erneut senden in {{time}}",
  verifyAccountResendCooldownHint:
    "Sie können einen neuen Link in {{time}} anfordern.",
  verifyAccountResendLoading: "Bestätigungslink wird gesendet...",
  verifyAccountResendSuccess: "Ein neuer Bestätigungslink wurde gesendet.",
  verifyAccountResendWaiting:
    "Bitte warten Sie {{time}}, bevor Sie den Link erneut senden.",
  resetTitle: "Neues Passwort vergeben",
  resetSubtitle: "Bitte gib dein neues Passwort ein.",
  resetInvalidLink: "Ungültiger oder abgelaufener Link.",
  resetErrorTitle: "Passwort konnte nicht geändert werden.",
  resetErrorHint: "Der Link ist ungültig oder abgelaufen.",
  resetSuccess: "Passwort erfolgreich geändert.",
  resetSuccessBody: "Dein Passwort wurde aktualisiert.",
  resetBackToLogin: "Zurück zum Login",
  resetPasswordLabel: "Neues Passwort",
  resetConfirmLabel: "Bestätigen",
  resetSave: "Passwort speichern",
  resetSaving: "Speichere...",
  resetPasswordInvalid: "Das Passwort erfüllt nicht die Anforderungen.",
  resetRequestTitle: "Passwort zurücksetzen",
  resetRequestSubtitle: "Gib deine E-Mail-Adresse ein, um einen Link zum Zurücksetzen zu erhalten.",
  resetRequestSend: "Link senden",
  resetRequestSent:
    "Falls ein Konto mit dieser E-Mail existiert, wurde eine E-Mail gesendet.",
  resetMissingData: "Daten fehlen.",
  resetLinkUsed: "Dieser Link wurde bereits verwendet.",
  resetLinkExpired: "Der Link ist abgelaufen.",
  refreshTokenInvalid: "Refresh-Token ist ungültig.",
  refreshTokenUserNotFound: "Benutzer nicht gefunden.",
  refreshTokenNotFound: "Token nicht gefunden.",
  refreshTokenExpired: "Token ist abgelaufen oder widerrufen.",
  maintenanceAdminOnly:
    "Wartungsmodus aktiv. Aktuell können sich nur Administratoren anmelden.",
};

export const account = {
  title: "Mein Account",
  subtitle: "Verwalten Sie Ihre Kontoinformationen und Einstellungen",
  profile: "Profil",
  settings: "Einstellungen",
  messages: "Nachrichten",
  activity: "Aktivität",
  email: "E-Mail-Adresse",
  username: "Benutzername",
  password: "Passwort",
  role: "Rolle",
  memberSince: "Mitglied seit",
  websitesAdded: "Websites hinzugefügt",
  categorizations: "Kategorisierungen",
  edits: "Bearbeitungen",
  recentActivity: "Letzte Aktivitäten",
  administrator: "Administrator",
  registeredUser: "Registrierter Nutzer",
  statistics: "Statistiken",
  totalActivity: "Gesamtaktivität",
  activitySummary: "Aktivitätsübersicht",
  activitySummaryDesc: "Überblick über Ihre letzten Aktionen",
  activitySearchLabel: "Aktivitäten durchsuchen",
  activitySearchPlaceholder: "Aktionen oder Titel suchen",
  activityFilterLabel: "Nach Typ filtern",
  activityFilterAll: "Alle Typen",
  activityFilterTimeLabel: "Zeitraum",
  activityFilterTime: "Zeitraum",
  activityFilterTimeALL: "Gesamter Zeitraum",
  activityFilterTimeWEEK: "Letzte Woche",
  activityFilterTimeMONTH: "Letzter Monat",
  activityFilterTimeYEAR: "Letztes Jahr",
  activityResultsPerPage: "Ergebnisse pro Seite",
  activityEmpty: "Keine Aktivitäten gefunden.",
  activityCount: "{{count}} Einträge insgesamt",
  activityResultsSummary: "{{start}}-{{end}} von {{count}} Ergebnissen",
  profilePictureUpload: "Profilbild-Upload",
  profilePictureDescription:
    "Diese Funktion würde normalerweise einen Datei-Upload öffnen.",
  emailChangeRequested: "E-Mail-Änderung angefordert",
  emailChangeDescription:
    "Bitte bestätigen Sie die Änderung über den Link in Ihrer E-Mail.",
  emailChangeVerifySubtitle: "Ihre E-Mail-Adresse wurde aktualisiert.",
  emailChangeVerifyBody:
    "Wir haben Ihnen eine E-Mail an {{email}} gesendet. Bitte klicken Sie auf den Link, um die Änderung zu bestätigen.",
  emailChangeCompleteTitle: "E-Mail-Änderung abgeschlossen",
  emailChangeCompleteSubtitle: "Ihre E-Mail-Adresse wurde aktualisiert.",
  emailChangeCompleteNextStep:
    "Sie können sich jetzt mit Ihrer neuen E-Mail anmelden.",
  usernameChanged: "Benutzername erfolgreich geändert",
  passwordChanged: "Passwort erfolgreich geändert",
  passwordChangeConfirmation: "Sie erhalten eine Bestätigungs-E-Mail.",
  verified: "Bestätigt",
  notVerified: "Nicht bestätigt",
  changeEmail: "E-Mail-Adresse ändern",
  changeEmailDescription:
    "Ändern Sie Ihre E-Mail-Adresse. Sie erhalten einen Bestätigungslink.",
  newEmail: "Neue E-Mail-Adresse",
  emailRequired: "Bitte geben Sie eine E-Mail-Adresse ein.",
  emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
  emailTooLong: "E-Mail-Adressen dürfen höchstens 255 Zeichen lang sein.",
  changeUsername: "Benutzername ändern",
  changeUsernameDescription: "Ändern Sie Ihren Benutzernamen",
  newUsername: "Neuer Benutzername",
  usernameTaken: "Dieser Benutzername ist bereits vergeben.",
  usernameUnchanged: "Bitte geben Sie einen anderen Benutzernamen ein.",
  usernameRequired: "Bitte geben Sie einen Benutzernamen ein.",
  usernameTooLong: "Benutzernamen dürfen höchstens 255 Zeichen lang sein.",
  emailUnchanged: "Bitte geben Sie eine andere E-Mail-Adresse ein.",
  emailTaken: "Diese E-Mail-Adresse wird bereits verwendet.",
  currentPasswordIncorrect: "Das aktuelle Passwort ist falsch.",
  passwordUnchanged: "Bitte wählen Sie ein anderes Passwort.",
  changePassword: "Passwort ändern",
  changePasswordDescription: "Ändern Sie Ihr Passwort",
  currentPassword: "Aktuelles Passwort",
  newPassword: "Neues Passwort",
  confirmPassword: "Passwort bestätigen",
  change: "Ändern",
  recentActivityDescription: "Ihre letzten Aktionen im System",
  messagesDescription: "Updates von Administratoren und Systemereignissen.",
  messagesEmpty: "Noch keine Nachrichten vorhanden.",
  messagesUnread: "Ungelesen",
  messagesRead: "Gelesen",
  messagesSender: "Absender",
  messagesSentAt: "Gesendet",
  messagesMarkRead: "Als gelesen markieren",
  messagesMarkAllRead: "Alle als gelesen markieren",
  messagesResultsPerPage: "Nachrichten pro Seite",
  messagesResultsSummary: "{{start}}-{{end}} von {{count}} Nachrichten",
  messagesFromSystem: "System",
  messagesTypeSYSTEM: "System",
  messagesTypeADMIN: "Admin",
  messagesTypeUSER: "Nutzer",
  messagesAdminLink: "Nachrichten im Admin-Dashboard senden",
  messagesAdminDescription:
    "Öffnet den Admin-Bereich, um Nachrichten an Nutzer zu senden.",
  messagesAdminCta: "Admin-Nachrichten öffnen",
  ticketAdminLink: "Tickets im Admin-Dashboard verwalten",
  ticketAdminDescription:
    "\u00d6ffnet den Admin-Bereich, um eingehende Bug- und Feature-Tickets zu bearbeiten.",
  ticketAdminCta: "Admin-Tickets \u00f6ffnen",
  tickets: "Tickets",
  ticketsDescription: "Melde Bugs, Feature-Wünsche und verfolge Antworten inklusive Anhängen.",
  ticketCreateTitle: "Ticket erstellen",
  ticketInboxTitle: "Meine Tickets",
  ticketTitleLabel: "Titel",
  ticketTitlePlaceholder: "Kurze Zusammenfassung deines Anliegens",
  ticketType: "Typ",
  ticketTypeBUG: "Bug",
  ticketTypeFEATURE: "Feature",
  ticketTypeFEEDBACK: "Feedback",
  ticketMessage: "Nachricht",
  ticketMessagePlaceholder:
    "Beschreibe dein Problem, deinen Wunsch oder deine Frage...",
  ticketAttachments: "Anhänge (bis zu 5 Bilder)",
  ticketAttachmentsLimit: "Du kannst bis zu 5 Bilder pro Nachricht anhängen.",
  ticketFilesSelected: "Dateien ausgewählt",
  ticketCreateAction: "Ticket erstellen",
  ticketCreated: "Ticket erstellt.",
  ticketFilterAll: "Alle Status",
  ticketListEmpty: "Keine Tickets gefunden.",
  ticketMessagesShort: "Nachrichten",
  ticketAttachmentsShort: "Anhänge",
  ticketReplyTitle: "Antworten",
  ticketReplyPlaceholder: "Weitere Nachricht schreiben...",
  ticketReplyAction: "Antwort senden",
  ticketCloseDefault: "Standard-Schließnachricht",
  ticketCloseCustom: "Eigene Schließnachricht",
  ticketCloseMessagePlaceholder: "Eigene Schließnachricht eingeben...",
  ticketCloseAction: "Ticket schließen",
  ticketCloseConfirmTitle: "Ticket schlie\u00dfen",
  ticketCloseConfirmDescription:
    "Du kannst es im Wiederer\u00f6ffnungszeitraum durch eine neue Nachricht erneut \u00f6ffnen.",
  ticketCloseConfirmAction: "Ticket schlie\u00dfen",
  ticketClosed: "Ticket geschlossen.",
  ticketOpenAttachment: "Öffnen",
  ticketSystemReopenedAfterMessage: "Ticket nach neuer Nachricht wieder ge\u00f6ffnet.",
  ticketSystemReopenedByAdmin: "Ticket durch Admin wieder ge\u00f6ffnet.",
  ticketSystemClosedByReporter: "Ticket durch Meldenden geschlossen.",
  ticketSystemClosedByAdministrator: "Ticket durch Admin geschlossen.",
  ticketSystemAttachmentRemovedByAdmin:
    "Anhang durch Admin entfernt ({{admin}}): {{filename}}",
  ticketTitleRequired: "Bitte gib einen Titel ein.",
  ticketMessageOrAttachmentRequired:
    "Bitte Nachricht oder mindestens einen Anhang angeben.",
  ticketCustomCloseRequired: "Eigene Schließnachricht ist erforderlich.",
  ticketReopenUntil: "Wiedereröffnung möglich bis",
  ticketStatusOPEN: "Offen",
  ticketStatusIN_PROGRESS: "In Bearbeitung",
  ticketStatusCLOSED: "Geschlossen",
  dataPrivacyTitle: "Daten & Datenschutz",
  dataPrivacyDescription:
    "Laden Sie Ihre personenbezogenen Daten herunter und verwalten Sie die Kontolöschung.",
  aiSearchToggleLabel: "KI-Suche",
  aiSearchStatusOn: "AN",
  aiSearchStatusOff: "AUS",
  aiSearchStatusForcedOff: "ERZWUNGEN AUS (Admin)",
  aiSearchStatusHintOn:
    "Natürliche Sprache wird aktiv in Kategorie-, Regions- und Textfilter aufgeteilt.",
  aiSearchStatusHintOff:
    "Nur Textsuche aktiv. Schalten Sie die KI-Suche ein, um Kategorien und Regionen automatisch zu erkennen.",
  aiSearchStatusHintForcedOff:
    "Die KI-Suche ist per Systemeinstellung deaktiviert. Ihre gespeicherte Präferenz bleibt erhalten.",
  aiSearchTurnOn: "KI-Suche einschalten",
  aiSearchTurnOff: "KI-Suche ausschalten",
  dataExportButton: "Meine Daten herunterladen",
  dataExportLoading: "Export wird vorbereitet...",
  dataExportSuccess: "Ihr Datenexport wurde heruntergeladen.",
  dataExportFailed: "Der Datenexport konnte nicht heruntergeladen werden.",
  accountDeleteDescription:
    "Beim Löschen Ihres Kontos werden Ihre personenbezogenen Daten entfernt. Beiträge zu Websites werden anonymisiert.",
  accountDeleteButton: "Konto löschen",
  accountDeleteConfirmTitle: "Konto dauerhaft löschen",
  accountDeleteConfirmDescription:
    "Dieser Vorgang kann nicht rückgängig gemacht werden. Geben Sie Ihr aktuelles Passwort ein.",
  accountDeleteConfirmButton: "Dauerhaft löschen",
  accountDeleteLoading: "Konto wird gelöscht...",
  accountDeletePasswordRequired: "Bitte geben Sie Ihr aktuelles Passwort ein.",
  accountDeleteSuccess: "Ihr Konto wurde gelöscht.",
  accountDeleteFailed: "Ihr Konto konnte nicht gelöscht werden.",
  websiteAdded: "Website hinzugefügt",
  categorizationEdited: "Kategorisierung bearbeitet",
  categorizationPerformed: "Kategorisierung durchgeführt",
};

export const activity = {
  CREATE: "Erstellt",
  UPDATE: "Aktualisiert",
  DELETE: "Gelöscht",
  RESTORE: "Wiederhergestellt",
  SUGGEST: "Vorgeschlagen",
};

export const profilePicture = {
  title: "Profilbild",
  subtitle: "Wähle ein Bild für dein Profil.",
  previewAlt: "Profilbild-Vorschau",
  previewLabel: "Wird überall in deinem Profil angezeigt.",
  previewNoticeTitle: "Dies ist eine Vorschau",
  previewNoticeBody: "Änderungen werden automatisch gespeichert.",
  select: "Bild auswählen",
  change: "Bild ändern",
  remove: "Bild entfernen",
  invalidFile:
    "Diese Datei scheint kein gültiges Bild zu sein. Bitte wähle ein anderes.",
  maxOriginal: "Dieses Bild ist zu groß. Bitte wähle eine kleinere Datei.",
  empty: "Bitte wählen Sie eine nicht-leere Bilddatei.",
  invalidType: "Dieser Dateityp wird nicht unterstützt.",
  cropInstruction: "Änderungen werden automatisch gespeichert.",
  mobileHint: "Der Profilbild-Editor ist weiter unten. Antippen zum Springen.",
  apply: "Übernehmen",
  upload: "Bild speichern",
  uploading: "Bild wird gespeichert...",
  hint: "Das Bild wird automatisch optimiert.",
  uploadSuccess: "Dein Profilbild wurde aktualisiert.",
  removeSuccess: "Profilbild entfernt.",
  tooLarge: "Das Bild ist zu groß.",
  uploadWarning:
    "Dieses Bild konnte nicht gespeichert werden. Bitte versuche ein anderes.",
  registrationNote:
    "Optional: Ihr Bild wird direkt nach der Registrierung hochgeladen.",
  notFound: "Profilbild nicht gefunden.",
  uploadFailed:
    "Dieses Bild konnte nicht gespeichert werden. Bitte versuche ein anderes.",
  uploadFailedDifferent:
    "Dieses Bild konnte nicht gespeichert werden. Bitte versuche ein anderes.",
  uploadNetworkError:
    "Beim Speichern des Bildes ist etwas schiefgelaufen. Bitte versuche es erneut.",
  authExpired:
    "Du bist nicht mehr angemeldet. Bitte melde dich erneut an, um dein Bild zu speichern.",
  controls: {
    move: "Verschieben",
    moveHint: "Ziehe das Bild",
    zoom: "Zoom",
    zoomIn: "Hineinzoomen",
    zoomOut: "Herauszoomen",
    zoomSliderHint: "Schiebe den Regler oder nutze + / -",
    rotate: "Drehen",
    rotateLeft: "90° nach links drehen",
    rotateRight: "90° nach rechts drehen",
    rotationValue: "Winkel:",
    reset: "Zurücksetzen",
  },
};

